import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { fetchUserUmbrellas } from '@modules-deprecated/app/umbrellas/query-api'

import { defaultStaleTime } from '../config/queryClient'
import { QueryKeys } from '../enums/queryKeys'

// Shares the cache entry with `UserUmbrellasContextProvider`, so it works in mount points that don't render that provider
export const useFetchUserUmbrellas = () => {
  const { data: userUmbrellasData, ...rest } = useQuery([QueryKeys.Umbrella], fetchUserUmbrellas, {
    staleTime: defaultStaleTime,
  })

  const userUmbrellas = useMemo(() => userUmbrellasData?.data || [], [userUmbrellasData])

  return { ...rest, userUmbrellas }
}
